import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css'; // Base styles
// import './customDatePicker.css'; // We'll add black theme overrides here
import { format } from 'date-fns';
import { getDateRange } from './GetDateRange.js';
import "../Home/Accodion.css"
import { FaAngleDown } from 'react-icons/fa';

const QUICK_FILTERS = [
    'Today',
    'Yesterday',
    'Last 7 Days',
    'Last 30 Days',
    'This Month',
    'Last Month',
    'Life Time',
    // 'Custom Range'
];

function DateFilter({ onDateChange, defaultFilterType }) {
    const [filterType, setFilterType] = useState(defaultFilterType);
    const [showCalendar, setShowCalendar] = useState(false);
    const [showDropdown, setShowDropdown] = useState(false);
    // We'll store the actual date range in state
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    useEffect(() => {
        setFilterType(defaultFilterType)
    }, [defaultFilterType])
    // Whenever filterType changes (and is not "Custom Range"), update date range from getDateRange
    useEffect(() => {
        // if (filterType !== 'Custom Range') {
        const { startDate, endDate } = getDateRange(filterType);
        setStartDate(startDate);
        setEndDate(endDate);
        //     setShowCalendar(false);
        // } else {
        // setShowCalendar(!showCalendar);
        // }
    }, [filterType]);


    useEffect(() => {
        // Maybe store old values in a ref and compare
        onDateChange({ filterType, startDate, endDate });
    }, [filterType, startDate, endDate, onDateChange]);
    // Format the date range to display in the input
    const formattedRange = `${format(startDate, 'MM/dd/yyyy')} - ${format(endDate, 'MM/dd/yyyy')}`;

    // Called by react-datepicker whenever the user selects a new range
    const onRangeChange = (dates) => {
        // `dates` is an array: [startDate, endDate]
        setShowDropdown(false);
        const [start, end] = dates;
        setStartDate(start);
        setEndDate(end);

    };

    const handleFilterChange = (e) => {
        setFilterType(e.target.value);
        setShowDropdown(false);
    };

    const handleInputClick = () => {
        // Only toggle the calendar if filterType is "Custom Range"
        // if (filterType === 'Custom Range') {
        setShowCalendar(!showCalendar);
        // }
    };

    return (
        <div className="relative inline-block">
            <div className='flex flex-col md:flex-row mt-4 md:mt-0 text-sm space-y-3 md:space-y-0'>
                <div>
                    {/* Dropdown for quick filters */}
                    <button
                        onClick={() => setShowDropdown(!showDropdown)}
                        className="w-full border text-sm border-gray-300 px-4 py-2 rounded-md bg-white hover:bg-slate-200 transition duration-200 hover:text-black flex justify-between items-center"
                    >
                        {filterType}
                        <span className="ml-2"><FaAngleDown className='text-slate-300' /></span> {/* Dropdown arrow */}
                    </button>

                    {/* Dropdown Menu */}
                    {showDropdown && (
                        <div className="absolute bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-700 shadow-lg rounded-md z-10">
                            {QUICK_FILTERS.map((filter) => (
                                <div
                                    key={filter}
                                    className="px-4 py-2 text-gray-700 dark:text-white hover:bg-slate-100 cursor-pointer text-sm transition duration-200"
                                    onClick={() => {
                                        setFilterType(filter);
                                        setShowDropdown(false);
                                    }}
                                >
                                    {filter}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
                {/* Show the text box with the current range */}
                <input
                    type="text"
                    className="border border-gray-300 text-sm px-4 py-1.5 rounded-md focus:outline-none md:ml-2 cursor-pointer bg-white transition duration-200 hover:bg-slate-200 hover:text-black"
                    value={formattedRange}
                    onClick={handleInputClick}
                    readOnly
                />
            </div>
            {/* If filterType is "Custom Range" and showCalendar is true, show the range picker */}
            {/* {filterType === 'Custom Range' && showCalendar && ( */}
            {showCalendar && (
                // <div
                //     className="absolute bg-white border border-gray-300 z-10 mt-2 shadow-lg rounded-md w-[250px] md:max-w-[506px] md:py-3 pt-0 pb-3"
                // >
                <div className="flex flex-col items-center">
                    <div className="absolute bg-white border py-3 border-gray-300 z-10 mt-2 shadow-lg rounded-md ">
                        <div className="flex flex-col items-center">
                            {/* Date Picker */}
                            <DatePicker
                                selected={startDate}
                                onChange={onRangeChange}
                                startDate={startDate}
                                endDate={endDate}
                                selectsRange
                                inline
                                monthsShown={1} // Shows 1 month
                                calendarClassName="custom-calendar dark-calendar responsive-calendar" // Custom class for styling
                            />

                            {/* Buttons inside the Date Table */}
                            <div className="flex flex-col sm:flex-row gap-3 px-3 mt-3 w-full">
                                <button
                                    className="bg-gray-500 w-full sm:w-auto flex-1 text-white px-5 py-1 text-sm rounded-lg shadow-md hover:bg-gray-600 transition duration-200 focus:outline-none text-center"
                                    onClick={() => {
                                        setShowCalendar(false);
                                        setFilterType(defaultFilterType);
                                    }}
                                >
                                    Clear
                                </button>
                            </div>
                        </div>
                    </div>


                </div>
                // </div>


            )}
        </div>

    );
}

export default DateFilter;
